import { createContext, useContext, useRef, useState, useCallback } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const ConfirmContext = createContext(null);
export const useConfirm = () => useContext(ConfirmContext);

const DEFAULT = { open: false, title: "Confirmation", description: "", confirmLabel: "Confirmer", cancelLabel: "Annuler", danger: false };

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(DEFAULT);
  const resolver = useRef(null);

  const confirm = useCallback((opts = {}) => new Promise((resolve) => {
    resolver.current = resolve;
    setState({ open: true, title: opts.title || "Confirmation", description: opts.description || "", confirmLabel: opts.confirmLabel || "Confirmer", cancelLabel: opts.cancelLabel || "Annuler", danger: !!opts.danger });
  }), []);

  const close = (val) => { setState((s) => ({ ...s, open: false })); if (resolver.current) { resolver.current(val); resolver.current = null; } };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(o) => { if (!o) close(false); }}>
        <AlertDialogContent data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{state.title}</AlertDialogTitle>
            {state.description ? <AlertDialogDescription>{state.description}</AlertDialogDescription> : null}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="confirm-cancel" onClick={() => close(false)}>{state.cancelLabel}</AlertDialogCancel>
            <AlertDialogAction data-testid="confirm-ok" onClick={() => close(true)}
              className={state.danger ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : ""}>
              {state.confirmLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}
